import { PagedResponse, Paging } from "@tm/models"
import { useInfiniteQuery } from "react-query"

export function useShowPagedCustomItems<TRequest, TData>(
    request: TRequest,
    { queryKey, dataFn }: { queryKey: unknown[]; dataFn(request: TRequest & Partial<Paging>): Promise<PagedResponse<TData>> },
    enabled?: boolean
) {
    return useInfiniteQuery(queryKey, async ({ pageParam = 1 }) => dataFn({ ...request, pageIndex: pageParam, pageSize: 50 }), {
        getNextPageParam: (lastPage) => {
            if (!lastPage.endOfList) {
                return lastPage.pageIndex + 1
            }
        },
        enabled: enabled === undefined || enabled,
    })
}
